import { AxiosResponse } from "axios";

import API from "../api";
import { PermissionsHierarchy, Resources } from "../models/resources";

const ROUTE_NAME = "resources";

const ResourceService = {
  async getAll(options?: any): Promise<AxiosResponse<Resources[]>> {
    return await API.get(`/${ROUTE_NAME}/list/all`, { params: options });
  },
  async getResourceHierarchy(): Promise<AxiosResponse<PermissionsHierarchy>> {
    return await API.get(`/permissions/getResourceHierarchy`);
  },
};

export default ResourceService;
